if (!customElements.get("gift-modal")) {
  class GiftModal extends ModalDialog {
    constructor() {
      super();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => {
          if(e.detail.sectionId !== this.dataset.section) return;
          this.show();
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if(e.detail.sectionId !== this.dataset.section) return;
          this.hide();
        });
      }
    }
    #unsub = null;

    connectedCallback() {
      super.connectedCallback();
      this.#unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === "cart-items") {
          return;
        }
        console.log(event);
        this.hide();
      });
    }
    disconnectedCallback() {
      this.#unsub?.();
      this.#unsub = null;
    }
  }

  customElements.define("gift-modal", GiftModal);
}
